import { Layout } from "antd";
import { Helmet } from "react-helmet-async";
import HomePageNavbarComponent from "../../../components/HomePageNavbarComponent/HomePageNavbarComponent";
import HomePageHeroSection from "../../../components/HomePageHeroSection/HomePageHeroSection";
import HomePageAnimatedSection from "../../../components/HomePageAnimatedSection/HomePageAnimatedSection";
import HomePageFooter from "../../../components/HomePageFooter/HomePageFooter";
import HomePageSecuritySection from "../../../components/HomePageSecuritySection/HomePageSecuritySection";
import HomePageQuestionSection from "../../../components/HomePageQuestionSection/HomePageQuestionSection";
import HomePageCreatorSection from "../../../components/HomePageCreatorSection/HomePageCreatorSection";
import { useTranslation } from "react-i18next";
import useHomePageInfos from "../../../hooks/global/useHomePageInfos";
import "./index.less";

const HomePage = () => {
  const { t } = useTranslation();
  useHomePageInfos(t);

  return (
    <Layout className="HomePageWrapper">
      <HomePageNavbarComponent />
      <HomePageHeroSection />
      <HomePageAnimatedSection />
      <HomePageSecuritySection />
      <HomePageCreatorSection />
      <HomePageQuestionSection />
      <HomePageFooter />
    </Layout>
  );
};

export default HomePage;
